import React from 'react';

import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import globalMessages from 'translations/messages/global-messages';

const AlignLeft = ({ intl, title, size = 20 }) => (
  <Tooltip
    title={title ?? intl.formatMessage(globalMessages.align_left)}
    placement="bottom"
    enterDelay={500}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      focusable="false"
      style={{ display: 'block' }}
    >
      <rect x="3" y="4.5" width="16" height="1.7" rx="0.85" fill="currentColor" />
      <rect x="3" y="8" width="11" height="1.7" rx="0.85" fill="currentColor" />
      <rect x="3" y="11.5" width="16" height="1.7" rx="0.85" fill="currentColor" />
      <rect x="3" y="15" width="11" height="1.7" rx="0.85" fill="currentColor" />
    </svg>
  </Tooltip>
);

AlignLeft.propTypes = {
  intl: PropTypes.object,
  title: PropTypes.string,
  size: PropTypes.number,
};

export default injectIntl(AlignLeft);
